import { DeleteFilled } from "@ant-design/icons";
import { Form, Spin, Upload } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import UploadFileIcon from "../../../image/AddCsv.png";
import FileAltLabel from "../../../image/DownloadSample.svg";
import "../../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
const bucketUrl = process.env.REACT_APP_BUCKET_URL;

const BulkPincodeUpload = ({
  newPincodeAdded,
  setNewPincodeAdded,
  handleCancelBulk,
}) => {
  const { t } = useTranslation();
  const { Dragger } = Upload;
  const [uploadFile, setUploadFile] = useState("");
  const [apiloading, setapiLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [fileName, setFileName] = useState(null);

  const formRef = useRef();
  //  Function to handle cancellation and reset form
  const backToList = () => {
    handleCancelBulk();
    handleDeleteFile();
  };
  // Handles form submission 
  const handleSubmit = async () => {
    try {
      setBtnLoading(true);

      if (!uploadFile) {
        ErrorNotificationMsg(t("msg_pleaseUploadFile"));
        setBtnLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("upload_file", uploadFile);
      setapiLoading(true);

      const apiResponse = await postRequest("pincode-bulk-upload/", formData);
      if (apiResponse.data.status) {
        SuccessNotificationMsg(t("msg_uploadSuccess"));
        setBtnLoading(false);
        handleDeleteFile();
        setNewPincodeAdded(!newPincodeAdded);
        handleCancelBulk();
      } else {
        ErrorNotificationMsg(apiResponse.data.data);
        setBtnLoading(false);
      }
      setapiLoading(false);
    } catch (error) {
      setBtnLoading(false);
      setapiLoading(false);
    }
  };

  // Function To Delete the file
  const handleDeleteFile = () => {
    setUploadFile("");
    setFileName(null);
  };

  // function for uploading CSV file
  const uploadProps = {
    accept: ".csv",
    showUploadList: false,
    beforeUpload: (file) => {
      setUploadFile(file);
      setFileName(file.name);
      return false;
    },
  };

  return (
    <div className="uploadwrap">
      <div className="uploadinside">
        <div className="ImportCSV">
          <Spin spinning={apiloading}>
            <Form className="ModalForm" autoComplete="off" ref={formRef}>
              <Dragger {...uploadProps}>
                <div className="AddCssIcon">
                  <Link>
                    {" "}
                    <img
                      className="BulkDownload"
                      src={UploadFileIcon}
                      alt=""
                    />{" "}
                  </Link>
                </div>

                <h2>Drag and drop your CSV file here</h2>
                <h3>Or select file your computer</h3>
              </Dragger>
              <div className="UploadedFileIcon">
                {fileName}

                {uploadFile && (
                  <DeleteFilled
                    className="DeleteGradiantBtn"
                    label="Delete"
                    onClick={handleDeleteFile}
                  />
                )}
              </div>

              <div className="DnlSempleFile">
                <h2> Please Enter Zone Id Inside Excel From The Zone Table of Zone Module in Sidebar. </h2> <br />
                <h2>Download Sample File From Here</h2>
                <span>
                  {" "}
                  <a
                    href={bucketUrl}
                  >
                    <img
                      className="BulkDownloadIcon"
                      src={FileAltLabel}
                      alt=""
                    />{" "}
                    Get CSV Sample
                  </a>
                </span>
              </div>

              <div className="ModalPopupFooter mt-0">
                <ButtonField
                  className="CancelGradiantBtn"
                  type="primary"
                  htmlType="button"
                  label={t("cancel")}
                  onClick={backToList}
                />

                <ButtonField
                  className="SaveGradiantBtn"
                  label={t("import")}
                  htmlType="Submit"
                  onClick={handleSubmit}
                  loading={btnLoading}
                />
              </div>
            </Form>
          </Spin>
        </div>
      </div>
    </div>
  );
};

BulkPincodeUpload.propTypes = {
  handleCancelBulk: PropTypes.func.isRequired,
  newPincodeAdded: PropTypes.bool.isRequired,
  setNewPincodeAdded: PropTypes.func.isRequired,
};

export default BulkPincodeUpload;
